import bbox from '@turf/bbox'
import type { FeatureCollection } from 'geojson'
import type { MapRef } from 'react-map-gl'

export function getMapCardSizes() {
  if (typeof window !== 'undefined') {
    if (window.innerWidth > 1535) {
      return {
        list: 732,
        single: 500,
      }
    } else if (window.innerWidth > 1023) {
      return {
        list: 366,
        single: 400,
      }
    }
  }
  return {
    list: 0,
    single: 0,
  }
}

type Bounds = [[number, number], [number, number]]

const DEFAULT_ZOOM = 16
const MIN_ZOOM = 4
const MAX_ZOOM = 18

function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(value, max))
}

export function calculateIdealZoom(
  mapRef: MapRef | null,
  featureCollection: FeatureCollection
) {
  if (!mapRef) return DEFAULT_ZOOM

  const map = mapRef.getMap()
  const [minLng, minLat, maxLng, maxLat] = bbox(featureCollection)

  const bounds: Bounds = [
    [minLng, minLat],
    [maxLng, maxLat],
  ]

  const camera = map.cameraForBounds(bounds, { padding: 50 })

  if (!camera) return DEFAULT_ZOOM

  return clamp(Math.floor(camera.zoom), MIN_ZOOM, MAX_ZOOM)
}
